import { render, staticRenderFns } from "./ProductTotalsChart.vue?vue&type=template&id=38cc4131&"
import script from "./ProductTotalsChart.vue?vue&type=script&lang=js&"
export * from "./ProductTotalsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports